module.exports = __webpack_public_path__ + "static/media/widget-whwc.4cfbd40a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/widget-whwc.jpg
// module id = ./src/img/widget-whwc.jpg
// module chunks = 0